import FormationBuilderPage from "../FormationBuilderPage";

const technicienCvcProgram = [
  {
    title: "Fondamentaux du froid : thermodynamique, circuit frigorifique",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title: "Climatisation Mono-Split : constitution, installation, maintenance",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title:
      "Technologies frigorifiques avancées (Multi-Split, VRV/DRV, eau glacée)",
    img: "/assets/images/icon/ampoul.svg",
  },
  { title: "Habilitation électrique BR", img: "/assets/images/icon/light.svg" },
  {
    title: "Chaudières gaz / fioul / biomasse",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title: "Pompes à chaleur Air/Eau et Air/Air : COP et SCOP",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title: "Équilibrage hydraulique domestique et tertiaire",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title:
      "Fluides frigorigènes & réglementation F-GAS (R32, CO₂, hydrocarbures)",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Lecture et utilisation du diagramme enthalpique",
    img: "/assets/images/icon/fiche.svg",
  },
  {
    title: "Intervention sur VAT, GTB/GTC",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title:
      "Outillage frigoriste : manomètres, pompes à vide, stations de récupération",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Aptitude à la manipulation des fluides (examen théorique)",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Pratique intensive : tirage au vide, charge, brasage",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Production d'eau glacée & centrales frigorifiques",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title: "Centrales de Traitement d'Air (CTA)",
    img: "/assets/images/icon/ampoul.svg",
  },
  {
    title: "Dépannage CVC : recherche de pannes électriques et frigorifiques",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Gestion de la relation client & rédaction de compte-rendu",
    img: "/assets/images/icon/fiche.svg",
  },
  {
    title: "Communication et gestion des conflits",
    img: "/assets/images/icon/work-women.svg",
  },
  { title: "Travailler en équipe", img: "/assets/images/icon/work-women.svg" },
];

const TechnicienCvc = () => (
  <FormationBuilderPage
    category="BTP-Tertiaire"
    titleColor="#2424FF"
    title="Technicien CVC"
    duration={13}
    description={
      <p>
        Grâce au partenariat entre Liora et Vinci Facilities, rejoignez l'un des
        leaders français des services multi-techniques et de la performance
        énergétique des bâtiments en tant que Technicien CVC, après une
        formation accélérée de 13 semaines. Performance énergétique des
        bâtiments, maintenance multi-technique, smart building, transition
        environnementale... rythment le quotidien de nos équipes, pourquoi pas
        le vôtre ?
      </p>
    }
    image="/assets/images/home/btp-tertiaire.png"
    formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
    popupFormId="5705be1e-3baf-4d49-9f13-541b1db0c861"
    program={technicienCvcProgram}
  />
);

export default TechnicienCvc;
